export * from "ce/reducers/entityReducers/actionsReducer";
import { default as CE_actionsReducer } from "ce/reducers/entityReducers/actionsReducer";
export default CE_actionsReducer;
